module.exports = __webpack_public_path__ + "static/media/login-bg-bot.89c2592f.png";